module.exports = __webpack_public_path__ + "media/logo/ETS-Logo---White-fb5571c8.png";